//Lookups
export const productSearchByLookup = [
  { id: 1, name: "productName", value: "Product Name" },
  { id: 2, name: "orderNumber", value: "Order Number" },
  { id: 3, name: "machineId", value: "Serial Number" },
  { id: 4, name: "docLocation", value: "Storage Location" },
];
